import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "table table-hover" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 1 }

import { computed, toRef } from 'vue'
    import { tchMarked } from '@common/Common'
    import type { AlternativesComparisonDialogViewModel } from '@Alternatives/AlternativesLists/Components/AlternativesComparisonDialog'
    import type { AlternativesComparisonAlternativeReadModel, AlternativesComparisonAttributeReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativesComparisonDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)

    const data = computed(() => vm.value.data)

    const includeDescription = computed(() => data.value?.IncludeDescription ?? false)
    const includeStatus = computed(() => data.value?.IncludeStatus ?? false)

    const attributes = computed<AlternativesComparisonAttributeReadModel[]>(() =>
        data.value?.Attributes ?? []
    )

    const alternatives = computed<AlternativesComparisonAlternativeReadModel[]>(() =>
        data.value?.Alternatives ?? []
    )

    // ---------------- methods ----------------

    function getHtmlDescription(a: AlternativesComparisonAlternativeReadModel): string
    {
        return tchMarked(a.Description)
    }

    function getAttributeValue(a: AlternativesComparisonAlternativeReadModel, attrId: number): string
    {
        return a.Values.find(v => v.AttributeId === attrId)?.Value ?? ''
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Comparison", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1 /* CACHED */)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternatives.value, (a) => {
                              return (_openBlock(), _createElementBlock("th", {
                                key: a.Id
                              }, _toDisplayString(a.Name), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (includeDescription.value === true)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                _cache[3] || (_cache[3] = _createElementVNode("th", null, "Description", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternatives.value, (a) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: a.Id
                                  }, [
                                    _createElementVNode("span", {
                                      innerHTML: getHtmlDescription(a)
                                    }, null, 8 /* PROPS */, _hoisted_10)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          (includeStatus.value === true)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                _cache[4] || (_cache[4] = _createElementVNode("th", null, "Status", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternatives.value, (a) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: a.Id
                                  }, _toDisplayString(a.StatusName), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: attr.Id
                            }, [
                              _createElementVNode("th", null, _toDisplayString(attr.Name), 1 /* TEXT */),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternatives.value, (a) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: a.Id
                                }, _toDisplayString(getAttributeValue(a, attr.Id)), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})